<script setup></script>
<template>
    <svg viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.2456 7.52463H29.9823V14.2613" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22.123 15.3841L29.9825 7.52463" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.2635 29.9802H7.52686V23.2435" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.3863 22.1207L7.52686 29.9802" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>